

export class LicenseToDriveOutputWithoutStatus implements ILicenseToDriveOutputWithoutStatus {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id!: number;
    /** The license to drive name with 255 character limit */
    license_to_drive_name!: string;

    constructor(data?: ILicenseToDriveOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.license_to_drive_id = _data["license_to_drive_id"];
            this.license_to_drive_name = _data["license_to_drive_name"];
        }
    }

    static fromJS(data: any): LicenseToDriveOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["license_to_drive_id"] = this.license_to_drive_id;
        data["license_to_drive_name"] = this.license_to_drive_name;
        return data; 
    }
}

export interface ILicenseToDriveOutputWithoutStatus {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id: number;
    /** The license to drive name with 255 character limit */
    license_to_drive_name: string;
}

